export default __webpack_public_path__ + "static/media/icon-edit-white.105e3ffb.svg";